<script setup lang="ts">
import { computed } from 'vue'
import { useGameStore } from '@/stores/gameStore.ts'
import PlayerName from '@/components/Objects/PlayerName.vue'

const gameStore = useGameStore()

const topPlayerId = computed(() => {
  if (!gameStore.leaderboard || !Array.isArray(gameStore.leaderboard) || gameStore.leaderboard.length === 0) {
    return null
  }

  const topPlayer = gameStore.leaderboard.find((player: any) => player.position === 1)
  return topPlayer?.player_id || null
})
</script>

<template>
  <div class="">
    <div class="bg-slate-700 p-6">
      <div class="text-center space-y-4">
        <div class="text-6xl mb-4">🏆</div>

        <h2 class="text-3xl font-bold text-yellow-400">Game Over!</h2>

        <p class="text-lg text-slate-300">
          <template v-if="topPlayerId">
            Congratulations to <PlayerName :player-id="topPlayerId" /> for winning this arena!
          </template>
          <template v-else>
            The game has concluded. Thank you for playing!
          </template>
        </p>

        <div class="bg-slate-800 p-4 rounded-lg mt-6">
          <p class="text-slate-400">
            Thank you for playing Ferion! Your empire's achievements will be installed in the galactic leaderboards shortly!
          </p>
        </div>

        <div class="mt-6 text-sm text-slate-500">
          <p>Want another chance? Keep an eye on your email and discord, we will announce a new arena soon!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>